<template>
  <section>
    <div class="card">
      <div class="card-header">
        Vorlagen
      </div>
      <div class="card-body">
        <div class="row form-group">
          <col-label for="selectTemplateList">Auswahl</col-label>
          <div class="col-12 col-md-8">
            <select
              class="form-control"
              name="selectTemplateList"
              @change="setSelectedTemplate($event)"
              v-model="key"
            >
              <option
                :value="index"
                v-for="(template, index) in supportTicketResponseTemplates"
                :key="template.id"
                >{{ template.name }}</option
              >
            </select>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="row form-group">
          <col-label for="selectedTemplateSubject">Betreff</col-label>
          <div class="col-12 col-md-8">
            <input
              name="selectedTemplateSubject"
              class="form-control"
              type="text"
              v-model="selectedTemplate.subject"
            />
          </div>
          <div class="col-1"></div>
        </div>
        <div class="row form-group">
          <col-label for="selectedTemplateMessage">Nachricht</col-label>
          <div class="col-12 col-md-8">
            <textarea
              name="selectedTemplateMessage"
              class="form-control"
              type="text"
              v-model="selectedTemplate.message"
            ></textarea>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="row form-group">
          <div class="col-11">
            <v-button
              type="submit"
              class="btn-primary float-right"
              @click.native="updateSelectedTemplate()"
              >Aktualisieren</v-button
            >
          </div>
        </div>
      </div>
    </div>

    <resource
      resource="supportTicketResponseTemplate"
      :attributes="[
        {
          name: 'name',
          label: 'Name'
        },
        {
          name: 'subject',
          label: 'Betreff'
        },
        {
          name: 'message',
          label: 'Nachricht',
          type: 'TextareaSelector'
        }
      ]"
    >
      <div slot="title">
        Neue Vorlage erstellen
      </div>
    </resource>
  </section>
</template>

<script>
import store from "@/store";

export default {
  beforeRouteEnter(to, from, next) {
    store.dispatch("supportTicketResponseTemplate/read");
    store
      .dispatch("supportTicket/read", [
        {
          name: "where",
          attributes: {
            id: [Number(to.params.id)]
          }
        }
      ])
      .then(() => {
        next();
      });
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    original() {
      return this.$store.getters["supportTicket/find"](this.id);
    },
    supportTicketResponseTemplates() {
      return this.$store.getters[
        "supportTicketResponseTemplate/supportTicketResponseTemplates"
      ];
    }
  },
  data() {
    return {
      selectedTemplate: { name: "", subject: "", message: "" },
      key: [],
      message: "",
      subject: ""
    };
  },
  methods: {
    setSelectedTemplate(event) {
      this.selectedTemplate = {
        ...this.supportTicketResponseTemplates[event.target.value]
      };
    },
    useSelectedTemplate() {
      this.subject = this.selectedTemplate.subject;
      this.message = this.selectedTemplate.message;
    },
    updateSelectedTemplate() {
      const url = this.selectedTemplate.update_url;
      const tpl = {
        message: this.selectedTemplate.message,
        id: this.selectedTemplate.id,
        subject: this.selectedTemplate.subject
      };
      this.$http.patch(url, tpl).then(() => {
        this.$notify({
          title: "Template wurde aktualisiert",
          type: "success"
        });
      });
    }
  }
};
</script>
